import { Pipe, PipeTransform } from '@angular/core';
import { FileSizeFormatter } from 'src/app/view-model/utils/files/file-size-formatter';

@Pipe({
  name: 'fileSizeFormat'
})
export class FileSizeFormatPipe implements PipeTransform {

  transform(sizeInBytes: number, decimals = 0): string {
    const fileSizeFormatter = new FileSizeFormatter();
    return fileSizeFormatter.format(sizeInBytes, decimals);
  }

}
